import type { LanguageCode } from '@/shared/config/languages';
import type { NamePath } from 'antd/es/form/interface';

export const getFieldNameWithLang = (name: string | (string | number)[], lang: LanguageCode): NamePath => {
  if (Array.isArray(name)) {
    return [...name, lang];
  }
  return [name, lang];
};

export const getFieldKey = (fieldName: NamePath): string => {
  if (Array.isArray(fieldName)) {
    return fieldName.join('-');
  }
  return String(fieldName);
};
